import { NgModule } from "@angular/core";
import { SimulatorsListComponent } from "./simulators-list/simulators-list.component";
import { RouterModule, Routes } from "@angular/router";
import { PriceBandsListComponent } from "./price-bands-list/price-bands-list.component";
import { PricesListComponent } from "./prices-list/prices-list.component";
import { BookingWidgetShellComponent } from "./booking-widget-shell/booking-widget-shell.component";
import { BookingListComponent } from "./booking-list/booking-list.component";
import { ScheduledBookingListComponent } from "./scheduled-booking-list/scheduled-booking-list.component";
import { AddonListComponent } from "./addon-list/addon-list.component";
import { MyAccountComponent } from "./my-account/my-account.component";
import { PromoCodesListComponent } from "./promo-codes-list/promo-codes-list.component";
import { WaiversListComponent } from "./digital-waiver/waivers-list/waivers-list.component";
import { EntriesListComponent } from "./digital-waiver/entries-list/entries-list.component";
import { BookingSchedulerV2Component } from "./booking-scheduler-v2/booking-scheduler-v2.component";
import { MembershipPlansListComponent } from "./memberships/membership-plans-list/membership-plans-list.component";
import { MembershipCustomerListComponent } from "./memberships/membership-customer-list/membership-customer-list.component";
import { BookingMembershipWidgetShellComponent } from "./booking-membership-widget-shell/booking-membership-widget-shell.component";
import { MembershipCustomerWidgetShellComponent } from "./membership-customer-widget-shell/membership-customer-widget-shell.component";
import { LeagueListComponent } from "./league-list/league-list.component";
import { LeagueIterationsListComponent } from "./league-iterations-list/league-iterations-list.component";
import { LeagueMembersListComponent } from "./league-members-list/league-members-list.component";


const routes: Routes = [
  {
    path: 'my-account',
    component: MyAccountComponent
  },
  {
    path: 'simulators',
    component: SimulatorsListComponent,
  },
  {
    path: 'price-bands',
    component: PriceBandsListComponent,
  },
  {
    path: 'prices',
    component: PricesListComponent,
  },
  {
    path: 'scheduler-v2',
    component: BookingSchedulerV2Component
  },
  {
    path: 'bookingwidget',
    component: BookingWidgetShellComponent
  },
  {
    path: 'bookingmembershipwidget',
    component: BookingMembershipWidgetShellComponent
  },
  {
    path: 'membershipcustomerwidget',
    component: MembershipCustomerWidgetShellComponent
  },
  {
    path: 'bookings',
    component: BookingListComponent
  },
  {
    path: 'scheduled-bookings',
    component: ScheduledBookingListComponent
  },
  {
    path: 'addons',
    component: AddonListComponent
  },
  {
    path: 'promo-codes',
    component: PromoCodesListComponent
  },
  {
    path: 'digital-waivers',
    component: WaiversListComponent
  },
  {
    path: 'digital-waiver-entries',
    component: EntriesListComponent
  },
  {
    path: 'membership-plans',
    component: MembershipPlansListComponent
  },
  {
    path: 'membership-customers',
    component: MembershipCustomerListComponent
  },
  {
    path: 'leagues',
    component: LeagueListComponent
  },
  {
    path: 'league-iterations',
    component: LeagueIterationsListComponent
  },
  {
    path: 'league-members',
    component: LeagueMembersListComponent
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
  },
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class SimulatorBookingRoutingModule { }
